/*
|--------------------------------------------------------------------------
| State
|--------------------------------------------------------------------------
*/

const state = {
    googleLoaded: window.google !== undefined,
};

/*
|--------------------------------------------------------------------------
| Actions
|--------------------------------------------------------------------------
*/

const actions = {
    setGoogleLoaded({ commit }) {
        commit('setLoaded', true);
    },
};

/*
|--------------------------------------------------------------------------
| Mutations
|--------------------------------------------------------------------------
*/

const mutations = {
    setLoaded(state, loaded) {
        state.googleLoaded = loaded;
    },
};

/*
|--------------------------------------------------------------------------
| Export
|--------------------------------------------------------------------------
*/

export const google = {
    namespaced: true,
    actions,
    mutations,
    state,
};
